import * as React from 'react';

import * as styles from './styles.css';

interface INewReviewModalFooterProps {
  next: React.ReactElement<any>;
  prev: React.ReactElement<any> | null;
}

export const NewReviewModalFooter = ({ next, prev }: INewReviewModalFooterProps): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <div className={styles['button']}>{prev}</div>
      <div className={styles['button']}>{next}</div>
    </div>
  );
};
